export const PLAN_IDS = ['preview', 'explorer', 'teams', 'enterprise'] as const

export type PlanId = (typeof PLAN_IDS)[number]

export function isPlanId(value: unknown): value is PlanId {
  return PLAN_IDS.includes(value as PlanId)
}
export function getPricingPath(plan: PlanId): string {
  return `pricing?plan=${plan}`
}

export function getPlanFromPath(path?: string | null): PlanId | null {
  if (!path) return null

  const [pathname, search = ''] = path.replace(/^\//, '').split('?')
  if (pathname !== 'pricing') return null

  const plan = new URLSearchParams(search).get('plan')
  return isPlanId(plan) ? plan : null
}
